export default __webpack_public_path__ + "static/media/27.16db7994.png";